/**
 * Quote-module constants: wizard step names + URL paths used by the
 * step-driven layout (FlowLayout) and per-step `goTo()` calls.
 */

export const STEP_NAMES = [
  "Location & start date",
  "About your practice",
  "Create your account",
  "License & scope",
  "Coverage selection",
  "Underwriting questions",
  "Review & attest",
  "Payment",
  "Binder & Invoice",
];

export const STEP_PATHS = [
  "/",
  "/classification",
  "/register",
  "/license",
  "/coverage",
  "/underwriting",
  "/reviewDocusign",
  "/payment",
  "/binder-invoice",
];

export const TOTAL_STEPS = 9;

export const pathToStepIndex = (pathname) => {
  if (pathname === "/reviewDocusign") return 6;
  const i = STEP_PATHS.indexOf(pathname);
  return i >= 0 ? i : 0;
};
